import { useState, useEffect } from 'react';
import { Observable } from 'rxjs';

type AccountId = string | number | null;
type Data = Record<string, unknown>;
type AccountBalancePropsType = {
  api: (arg: Record<string, unknown>) => Observable<any>;
  accountId: AccountId;
  payload: Record<string, unknown>;
  getBalance: (arg: Record<string, unknown>) => number;
  getBalanceLabel?: (data: Data, accountId: AccountId) => string;
  enabled: boolean;
};

const useAccountBalance = ({
  accountId,
  api,
  enabled,
  getBalance,
  getBalanceLabel,
  payload
}: AccountBalancePropsType) => {
  const [balance, setBalance] = useState<number | null>(null);
  const [balanceLabel, setBalanceLabel] = useState<string | null>(null);
  const [fetchedAccount, setFetchedAccount] = useState<AccountId>(null);

  useEffect(() => {
    setBalance(null);
    setBalanceLabel(null);
    setFetchedAccount(null);
  }, [accountId]);

  useEffect(() => {
    if (enabled && balance === null) {
      const subscription = api({ ...payload, accountIds: [accountId] }).subscribe({
        next: (data: Data) => {
          if (getBalanceLabel) setBalanceLabel(getBalanceLabel(data, accountId));
          setBalance(getBalance(data) || 0);
          setFetchedAccount(accountId);
        }
      });
      return () => subscription.unsubscribe();
    }
  }, [accountId, enabled, getBalance, payload, api, balance, getBalanceLabel]);
  return [balance, fetchedAccount, balanceLabel];
};

export default useAccountBalance;
